import React, { SelectHTMLAttributes } from 'react'

interface SelectOption {
  value: string | number
  label: string
}

interface SelectProps extends Omit<SelectHTMLAttributes<HTMLSelectElement>, 'onChange'> {
  options: SelectOption[]
  onChange?: (value: string | number) => void
  className?: string
  chevronClassName?: string
}

export const Select: React.FC<SelectProps> = ({ 
  options, 
  onChange, 
  className = '', 
  chevronClassName = '',
  value,
  ...props 
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const val = e.target.value
    const numericValue = Number(val)
    onChange?.(isNaN(numericValue) ? val : numericValue)
  }

  return (
    <div className="flex-1 relative">
      <select
        value={value}
        onChange={handleChange}
        className={`w-full h-[50px] bg-[#3b3548] rounded-[10px] text-white font-proxima-regular text-[20px] px-[14px] pr-[40px] appearance-none outline-none cursor-pointer ${className}`}
        {...props}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <div className={`absolute right-[13px] top-1/2 -translate-y-1/2 pointer-events-none ${chevronClassName}`}>
        <svg width="18" height="18" viewBox="0 0 18 18">
          <path
            d="M4 6.5L9 12L14 6.5"
            stroke="rgb(var(--pcg-fg))"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
    </div>
  )
}